<div fxLayout="column" [class.max-heighted]="flagHeight" fxFlexFill #popupCont>

 <div class="full-screen" *ngIf="prodCopy.product_type < 2" >

    <!-- Content prod cat... -->
    <div class="scrolled" [style.height]="contHeight" (scroll)="onScroll($event)" #sideNavCont>

      <!-- Banner title scroll-->
      <div class="prod-dial-effect layout-padd" fxLayoutAlign="space-between center" angulartics2On="click"
        angularticsAction="closeProductDialog" angularticsCategory="products">

        <div class="fill-rest"></div>
        <mat-icon (click)="dialogRef.close()" class="clicked" style="color:white;">close</mat-icon>

      </div>

      <!-- Button open sidenav  -->
      <div fxHide fxShow.lt-md *ngIf="prodCopy.product_type === 2" class="clicked resp-open-basket"
        fxLayoutAlign="center center" (click)="rightNav.open()" #basketBtn>
        <div fxLayoutAlign="center center" class="primary vignette-quant">
          <span class="mat-caption">{{getTotalQuantFormule()}}</span>
        </div>
        <i class="material-icons primary-ico zindex10">shopping_cart</i>
      </div>

      <!-- Prod image  -->
      <app-slider-prod-gallery [prod]="prod" [width]="contWidth">
      </app-slider-prod-gallery>

      <!-- Content -->
      <div fxLayout="column" fxLayoutGap="20px" class="layout-padd divider-top " #scrollHere style="position: relative;">

        <!-- Banner title base-->
        <div>

          <div *ngIf="idPricePeriod > 0" class="layout-padd-1 rad-bord secondary clicked promo-badge"
            (click)="dialogsService.openPromoShedulesDial(idPricePeriod); $event.stopPropagation()" angulartics2On="click"
            angularticsAction="openPromoShedulesDial" angularticsCategory="product">
            <span class="mat-caption boldest">{{prodApi.getPricePeriodName(idPricePeriod) | capitalize}}</span>
          </div>

          <div  fxLayout="row"class="hidden-overflow" fxFlex>

            <div class="mat-headline boldest elipis">{{prod.name| capitalize}}</div>
        </div>
          <!-- <span class="mat-headline boldest">{{prodCopy.name | capitalize}}</span> -->

          <!-- badge point fidelite -->

          <div *ngIf="prodCopy.fidelity_points && from != 'formule'" class="clicked bd" fxLayoutAlign="center center"
            [matMenuTriggerFor]="menu"
            matTooltip=" {{'Product_fid' |translate}} {{prodCopy.fidelity_points}} {{'loyalty_points'|translate|lowercase}}">

            <div fxLayoutAlign="center center" class="great  fid-quant">

              <span class="mat-caption"> {{prodCopy.fidelity_points}}</span>
            </div>
            <i class="material-icons great-ico t">loyalty</i>
            <mat-menu #menu="matMenu">
              <div style="padding: 5px;">
                {{"Product_fid" |translate}} {{prodCopy.fidelity_points}} {{"loyalty_points"|translate|lowercase}}
              </div>
            </mat-menu>
          </div>


        </div>

        <!-- Prod description -->
        <div *ngIf="prodCopy.description" class="decode-html-line" style="font-size: 14px;">
          <div [innerHTML]="prodCopy.description"></div>
        </div>

        <!-- Prod Allergens -->
        <div fxLayout="column" fxLayoutGap="5px" *ngIf="prodCopy.allergens.length >0">

          <!-- Title  -->
          <div>
            <span class="mat-subheading-1 boldest">{{'allergens.title'|translate}} </span>
          </div>

          <!-- Allergens loop  -->
          <div fxLayout="row wrap" class="whited bordered-light rad-bord" style="padding: 10px;">
            <span class="mat-caption" *ngFor="let allergen of prodCopy.allergens; let last = last;">{{allergen.name}}
              {{last ? '' : ', '}}</span>
          </div>

        </div>

        <!-- Prod categories -->
        <div fxLayout="column" fxLayoutGap="20px">

          <div *ngIf="categories">
            <div *ngFor="let cat of categories;let indexCat=index" fxLayout="column" fxLayoutGap="5px" id="catScroll_{{indexCat}}">
              <div #scrollFormuleSuggested *ngIf="catTogo==indexCat && FormuleSuggested"></div>
              <!-- Title categorie + display error + reset button -->
              <div [class.animErr]="cat.asError" id="{{cat.id}}" fxLayout="column " fxLayoutAlign="start center">
                <div fxFlexFill fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

                  <div fxLayoutAlign="start center" fxLayout="row" class=" boldest decode-html-line"
                    style="overflow: hidden; margin-bottom: 10px !important;">
                    {{cat.name | capitalize}}
                  </div>



                  <div
                    fxLayoutAlign="{{!manageProdFormule(cat) && prodCopy.product_type === 2 && cat.max_quantity ?'start center' :'end center'}}"
                    class="mat-caption" fxLayout="row">
                    <div *ngIf="!cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.max' | translate:{'max_quantity': cat.max_quantity}"></div>
                    <div *ngIf="cat.min_quantity >0 && cat.max_quantity!==cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.minMax' | translate:{'min_quantity': cat.min_quantity,'max_quantity': cat.max_quantity}">
                    </div>
                    <div *ngIf="cat.min_quantity >0 && cat.max_quantity==cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.min' | translate:{'min_quantity': cat.min_quantity}"></div>
                    <span class=" boldest">&nbsp;{{cat.min_quantity >0 ? "*" : ""}}</span>
                    <!-- <div>par options ici {{cat.distinct_selection}}</div> -->
                  </div>


                  <div fxFlex fxLayout="row " fxLayoutAlign="end center" fxLayoutGap="5px"
                    *ngIf="!manageProdFormule(cat) && prodCopy.product_type === 2 && cat.max_quantity ">

                    <div class="clicked" (click)="removeProdCat(cat,'reset')" angulartics2On="click"
                      angularticsAction="resetFormuleCategorie" angularticsCategory="products">
                      <span class="reset-badge rad-bord mat-caption dark-ico boldest">{{"dialogs.prod.reset" |
                        translate}}</span>
                    </div>
                  </div>
                </div>

              </div>



              <!-- Prod type 1 -->

              <div class="whited bordered-light rad-bord" style="padding: 10px;" *ngIf="prodCopy.product_type === 1">

                <!-- Radio button (Only one choice)-->
                <mat-radio-group fxLayout="column" fxLayoutGap="5px"
                  *ngIf="cat.max_quantity === 1 && prodCopy.product_type === 1">

                  <mat-radio-button *ngFor="let det of cat.details" color="primary" [value]="det.product.id"
                    [checked]="det.product.quantity === 1" (change)="manageRadio(cat.details, det.product)"
                    angulartics2On="click" angularticsAction="selectProductOption" angularticsCategory="products">

                    <span class="mat-subheading-1 "style=" width: 95%;overflow: hidden; overflow-wrap: break-word; text-overflow: ellipsis;">{{det.product.name | capitalize}}</span>
                    <div fxFlex></div>

                    <span class="mat-caption" *ngIf="det.product.price !== 0">&nbsp;&nbsp;{{det.product.price<=0?"":"+"}}{{det.product.price
                      |discountVipFilter:merchantClient:det.product | priceFilter}}</span>


                  </mat-radio-button>

                </mat-radio-group>

                <!-- CheckBox button (Multiple choice) -->
                <div fxLayout="column" fxLayoutGap="5px" *ngIf="cat.max_quantity > 1 && prodCopy.product_type === 1">
                  <!-- <mat-checkbox *ngFor="let det of cat.details" color="primary" [value]="det.product.id"
                  [checked]="det.product.quantity === 1" (change)="manageCheckBox(cat, det.product)"
                  angulartics2On="click" angularticsAction="selectProductOption" angularticsCategory="products">

                  <div fxLayout=row fxLayoutAlign="start center" fxflex>

                    <span class="mat-subheading-1">{{det.product.name | capitalize}}</span>
                    <div fxFlex></div>

                    <span class="mat-caption" *ngIf="det.product.price > 0">&nbsp;&nbsp;+{{det.product.price
                      |discountVipFilter:merchantClient:det.product|priceFilter}}</span>


                  </div>

                </mat-checkbox> -->

                  <div *ngFor="let det of cat.details">


                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                      <!-- Remove -->
                      <div class="primary clicked quantity-toggle-btn " fxLayoutAlign="center center"
                        (click)="toggleProdQuantDet('-',cat, det.product)">
                        <span class="mat-caption">-</span>

                      </div>
                      <div class="mat-caption boldest" fxLayoutAlign="center center">{{det.product.quantity}}</div>


                      <!-- Add -->
                      <div class="primary clicked quantity-toggle-btn" fxLayoutAlign="center center"
                        (click)="toggleProdQuantDet('+',cat, det.product)">
                        <span class="mat-caption">+</span>
                      </div>


                      <div fxFlex  fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="hidden-overflow">

                        <div class="prod-title elipis">{{det.product.name | capitalize}}</div>

                        <div  class="mat-caption" *ngIf="det.product.price !== 0"> {{det.product.price<=0?"":"+"}}{{det.product.price
                          |discountVipFilter:merchantClient:det.product|priceFilter}}</div>

                      </div>

                    </div>




                  </div>

                </div>
                <!--  discountVipFilter pas si Prod type 2 -->
                <!-- Prod type 2 -->

                <div class="whited bordered-light rad-bord" style="padding: 10px;" fxLayout="row wrap"
                  *ngIf="prodCopy.product_type === 2">

                  <div *ngFor="let det of cat.details" style="height: 90px; padding: 5px;" class="rad-bord clicked"
                    (click)="openProdDial(det.product, 'formule', cat)" angulartics2On="click"
                    angularticsAction="selectProductDetail" angularticsCategory="products" fxFlex="100" fxFlex.xs="100">

                    <mat-card fxFlex class="rad-bord prod-card hidden-overflow" [class.primary]="det.product.quantity"
                      [matBadge]="det.product.quantity"
                      [matBadgeHidden]="cat.max_quantity > 1  && det.product.quantity < 1 || cat.max_quantity <= 1"
                      matBadgeColor="accent" >

                      <mat-card-header>

                        <div mat-card-avatar class="pos-img-cont avatar-prod-card"
                          [ngStyle]="{'background-image': 'url(' + ( det.product.image.length > 0 ? det.product.image[2] : default_prod) + ')'}">
                        </div>

                        <mat-card-title >
                          <div class="prod-title elipis" >
                          {{det.product.name | descFilter:50}}</div>
                        </mat-card-title>


                        <mat-icon *ngIf="cat.max_quantity === 1" class="infoinfo_ico"
                          [class.withed-ico]="det.quantity > 0" [class.dark-ico]="det.quantity === 0"
                          (click)="openProdDial(det.product, 'formule', cat, index, true);$event.stopPropagation()"
                          angulartics2On="click" angularticsAction="openInfoProduct" angularticsCategory="products">
                          info_outline</mat-icon>

                        <mat-card-subtitle *ngIf="det.product.price !== 0" style="font-size: 15px;"
                          class="prod-card-price mat-subheading-1 boldest dark-ico"
                          [class.whited-ico]="det.product.quantity">
                          {{det.product.price<=0?"":"+"}}{{det.product.price|discountVipFilter:merchantClient:det.product | priceFilter}}
                        </mat-card-subtitle>

                      </mat-card-header>

                    </mat-card>

                  </div>

                </div>

              </div>

            </div>
          </div>

          <!-- Prod Comment -->
          <div style="padding-top: 0;" *ngIf="prodCopy.enable_comment > 0">

            <mat-form-field appearance="outline" class="full-w form-nopadd" angulartics2On="click"
              angularticsAction="commentProd" angularticsCategory="products">
              <mat-label>{{"dialogs.prod.comment" | translate}}</mat-label>
              <input matInput type="text" placeholder="{{'dialogs.prod.comment' | translate}}" maxlength="200"
                [(ngModel)]="prodCopy.comment">
            </mat-form-field>

          </div>

          <!-- Compulsory asterisk -->
          <div *ngIf="prodCopy.product_type > 0" class="layout-padd-2">
            <span class="mat-caption">{{"dialogs.asterisk" | translate}}</span>
          </div>

        </div>

      </div>
    </div>

    <!-- Button toggle quantity + button submit prod Prod normal-->
    <div fxLayout="row" fxLayoutGap="10px" class="layout-padd-2" [ngStyle.gt-xs]="{'height': '60px'}"
      [ngStyle.xs]="{'height': '50px'}" ngClass.xs="resp-btn-bar" #fixedBar
      *ngIf="conditionStock() && !unaivalable || ((!conditionStock() && (from==='update'||from==='updatedetail')) && !unaivalable)">

      <!-- Prod detail -->

      <div *ngIf="+maxQuantityRest > 1 &&!productSuggested" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" >

        <div fxLayoutAlign="center center" class="btn-quant clicked btn-dyna primary" (click)="toggleProdQuant('-')"
          angulartics2On="click" angularticsAction="updateQuantityFromDialog" angularticsCategory="products" >
          <mat-icon class="whited-ico">remove</mat-icon>
        </div>

        <!--toggleProdQuant  -->
        <div fxLayoutAlign="center center">
          <span class="mat-subheading-1 boldest">{{prodCopy.quantity}}</span>
        </div>

        <div fxLayoutAlign="center center" class="btn-quant clicked btn-dyna primary" (click)="toggleProdQuant('+')"
          angulartics2On="click" angularticsAction="updateQuantityFromDialog" angularticsCategory="products" >
          <mat-icon class="whited-ico">add</mat-icon>
        </div>

      </div>

      <!-- Button -->
      <div fxLayoutAlign="center center" fxFlex>

        <button mat-raised-button fxLayoutAlign="center center" class="primary rounded-button" (click)="pushProd()"
        [class.mydisabled]="prodCopy&&prodCopy.novisible"  fxFlex angulartics2On="click"
          angularticsAction="{{ from === 'add' ? 'addProduct' :  from === 'update' ? 'updateProduct' : from === 'formule' ? 'addProductToMenu' : from === 'updatedetail' ? 'updateFormuleDetail' : ''}}"
          angularticsCategory="products" style="height: 30px;">

          <!-- ADD -->
          <span fxHide.xs *ngIf="FormuleSuggested || from === 'add'">{{"dialogs.prod.add" | translate}}</span>
          <span fxHide fxShow.xs *ngIf=" FormuleSuggested ||from === 'add'">{{'prodComponent.add' |translate}} </span>

          <!-- UPDATE -->

          <span fxHide.xs *ngIf="!FormuleSuggested && (from === 'update' || from === 'updatedetail')">{{"dialogs.prod.update" |
            translate}}</span>
          <span fxHide fxShow.xs *ngIf="!FormuleSuggested && ( from === 'update' ||from === 'updatedetail' ) ">{{'button.modify'|translate}} </span>

          <!-- FORMULE -->
          <span *ngIf="from === 'formule'">{{'prodComponent.addForm' |translate}}</span>




          <!-- TOTAL -->


          <span class="mat-subheading-1 boldest" ngClass.xs="mat-caption"
            *ngIf="getTotalPriceFormule()!== 0">&nbsp;&nbsp;({{(from
            === 'formule' || from === 'updatedetail') && getTotalPriceFormule()>0 ? '+' :''}}{{getTotalPriceFormule() | priceFilter}})</span>

        </button>

      </div>

    </div>

    <!-- Out of stock  -->
    <!-- <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" class="layout-padd-2 out-of-stock-button"
      [ngStyle.gt-xs]="{'height': '60px'}" [ngStyle.xs]="{'height': '50px'}" ngClass.xs="resp-btn-bar" #fixedBar
      *ngIf="(!conditionStock() && (from != 'update'|| from != 'updatedetail') ) || unaivalable"> -->

    <!-- new  -->
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" class="layout-padd-2 out-of-stock-button"
      [ngStyle.gt-xs]="{'height': '60px'}" [ngStyle.xs]="{'height': '50px'}" ngClass.xs="resp-btn-bar" #fixedBar
      *ngIf="(!conditionStock() && getUpdateFrom() ) || unaivalable">
      <span class="mat-title boldest">{{'prodComponent.unavailable' |translate}}  </span>
    </div>


  </div>

  <mat-sidenav-container *ngIf="prodCopy.product_type === 2">

    <mat-sidenav-content>

      <!-- Content prod cat... -->
      <div class="scrolled" [style.height]="contHeight" (scroll)="onScroll($event)" #sideNavCont>

        <!-- Banner title scroll-->

        <div #titleBanner class="prod-dial-effect" fxLayoutAlign="space-between center" angulartics2On="click"
          angularticsAction="closeProductDialog" angularticsCategory="products">

          <!-- <span [@toggleTitleBanner]="getToggleTitle" class="mat-title title-banner"
            style="color:white;">{{prodCopy.name | uppercase}}</span>-->
          <div class="fill-rest"></div>
          <mat-icon (click)="dialogRef.close()" class="clicked" style="color:white;">close</mat-icon>

        </div>

        <!-- Button open sidenav  -->
        <div fxHide fxShow.lt-md *ngIf="prodCopy.product_type === 2" class="clicked resp-open-basket"
          fxLayoutAlign="center center" (click)="rightNav.open()" #basketBtn>
          <div fxLayoutAlign="center center" class="great vignette-quant">
            <span class="mat-caption">{{getTotalQuantFormule()}}</span>
          </div>
          <i class="material-icons primary-ico">shopping_cart</i>
        </div>

        <!-- Prod image  -->
        <app-slider-prod-gallery [prod]="prodCopy" [width]="contWidth">
        </app-slider-prod-gallery>

        <!-- Content -->
        <div fxLayout="column" fxLayoutGap="20px" class="layout-padd divider-top" #scrollHere
          style="position: relative;">

          <!-- Banner title base-->
          <div>

            <div *ngIf="idPricePeriod > 0" class="layout-padd-1 rad-bord secondary clicked promo-badge"
              (click)="dialogsService.openPromoShedulesDial(idPricePeriod); $event.stopPropagation()" angulartics2On="click"
              angularticsAction="openPromoShedulesDial" angularticsCategory="product">
              <span class="mat-caption boldest">{{prodApi.getPricePeriodName(idPricePeriod) | capitalize}}</span>
            </div>
            <div  fxLayout="row"class="hidden-overflow" fxFlex>

              <div class="mat-headline boldest elipis">{{prod.name| capitalize}}</div>
          </div>
            <!-- <span class="mat-headline boldest">{{prodCopy.name | capitalize}}</span> -->


            <!-- badge point fidelite -->

            <div *ngIf="prodCopy.fidelity_points " class="clicked bd" fxLayoutAlign="center center"
              [matMenuTriggerFor]="menu"
              matTooltip=" {{'Product_fid' |translate}} {{prodCopy.fidelity_points}} {{'loyalty_points'|translate|lowercase}}">

              <div fxLayoutAlign="center center" class="great  fid-quant">

                <span class="mat-caption"> {{prodCopy.fidelity_points}}</span>
              </div>
              <i class="material-icons great-ico t">loyalty</i>
              <mat-menu #menu="matMenu">
                <div style="padding: 5px;">
                  {{"Product_fid_for" |translate}} {{prodCopy.fidelity_points}}
                  {{"loyalty_points"|translate|lowercase}}
                </div>
              </mat-menu>
            </div>



          </div>

          <!-- Prod description -->
          <div *ngIf="prodCopy.description" class="decode-html-line" style="
          font-size: 14px;">
            <p [innerHTML]="prodCopy.description"></p>
          </div>

          <!-- Prod Allergens -->
          <div *ngIf="prodCopy.allergens.length >0" fxLayout="column" fxLayoutGap="5px">

            <!-- Title  -->
            <div>
              <span class="mat-subheading-1 boldest">{{'prodComponent.allergens' |translate}}  </span>
            </div>

            <!-- Allergens loop  -->
            <div fxLayout="row wrap" class="whited bordered-light rad-bord" style="padding: 10px;">
              <span class="mat-caption" *ngFor="let allergen of prodCopy.allergens; let last = last;">{{allergen.name}}
                {{last ? '' : ', '}}</span>
            </div>

          </div>


          <!-- Prod categories -->
          <div fxLayout="column" *ngIf="categories" fxLayoutGap="20px">



            <div *ngFor="let cat of categories;let indexCat=index" fxLayout="column" fxLayoutGap="5px" id="catScroll_{{indexCat}}">
          <div #scrollFormuleSuggested *ngIf="catTogo==indexCat && FormuleSuggested"></div>

              <!-- Title categorie + display error + reset button -->
              <!-- <div [class.animErr]="cat.asError" id="{{cat.id}}" fxLayout="row wrap" fxLayoutAlign="start center">

                <span class="mat-subheading-1 boldest">frgdfthgjyuhkiomù*zert{{cat.name | capitalize}}</span>
                <span class="mat-caption boldest">&nbsp;&nbsp;|&nbsp;&nbsp;max: {{cat.max_quantity}}</span>
                <span class="mat-subheading-1 boldest">&nbsp;{{cat.compulsory === 1 ? " *" : ""}}&nbsp;</span>

                <div class="fill-rest"></div>

                <div class="clicked" (click)="removeProdCat(cat,'reset')"
                  *ngIf="!manageProdFormule(cat) && prodCopy.product_type === 2 && cat.max_quantity "
                  angulartics2On="click" angularticsAction="resetFormuleCategorie" angularticsCategory="products">
                  <span class="reset-badge rad-bord mat-caption dark-ico boldest">{{"dialogs.prod.reset" |
                    translate}}</span>
                </div>

              </div> -->


              <!-- Title categorie + display error + reset button -->
              <div [class.animErr]="cat.asError" id="{{cat.id}}" fxLayout="column " fxLayoutAlign="start center">
                <div fxFlexFill fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">

                  <div fxLayoutAlign="start center" fxLayout="row" class=" boldest decode-html-line"
                    style="overflow: hidden; margin-bottom: 10px !important;">
                    {{cat.name | capitalize}}
                  </div>




                  <div
                    fxLayoutAlign="{{!manageProdFormule(cat) && prodCopy.product_type === 2 && cat.max_quantity ?'start center' :'end center'}}"
                    class="mat-caption" fxLayout="row">
                    <div *ngIf="!cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.max' | translate:{'max_quantity': cat.max_quantity}"></div>
                    <div *ngIf="cat.min_quantity >0 && cat.max_quantity!==cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.minMax' | translate:{'min_quantity': cat.min_quantity,'max_quantity': cat.max_quantity}">
                    </div>
                    <div *ngIf="cat.min_quantity >0 && cat.max_quantity==cat.min_quantity"
                      [innerHtml]="'maxminOptionFormule.min' | translate:{'min_quantity': cat.min_quantity}"></div>
                    <span class=" boldest">&nbsp;{{cat.min_quantity >0 ? "*" : ""}}</span>

                    <!-- <div>par options par option product_type2{{cat.distinct_selection}}</div> -->
                  </div>


                  <div fxFlex fxLayout="row " fxLayoutAlign="end center" fxLayoutGap="5px"
                    *ngIf="!manageProdFormule(cat) && prodCopy.product_type === 2 && cat.max_quantity ">

                    <div class="clicked" (click)="removeProdCat(cat,'reset')" angulartics2On="click"
                      angularticsAction="resetFormuleCategorie" angularticsCategory="products">
                      <span class="reset-badge rad-bord mat-caption dark-ico boldest">{{"dialogs.prod.reset" |
                        translate}}</span>
                    </div>
                  </div>
                </div>

              </div>



              <!-- Prod type 1 -->
              <div class="whited bordered-light" style="padding: 10px;" *ngIf="prodCopy.product_type === 1">

                <!-- Radio button (Only one choice)-->
                <mat-radio-group fxLayout="column" fxLayoutGap="5px"
                  *ngIf="cat.max_quantity === 1 && prodCopy.product_type === 1">

                  <mat-radio-button *ngFor="let det of cat.details" color="primary" [value]="det.product.id"
                    [checked]="det.product.quantity === 1" (change)="manageRadio(cat.details, det.product)"
                    angulartics2On="click" angularticsAction="selectProductOption" angularticsCategory="products">


                    <span class="mat-subheading-1">{{det.product.name | capitalize}}</span>
                    <div fxFlex></div>

                    <span class="mat-caption" *ngIf="det.product.price !== 0">&nbsp;&nbsp; {{det.product.price<=0?"":"+"}}{{det.product.price
                      |discountVipFilter:merchantClient:det.product | priceFilter}}</span>


                  </mat-radio-button>

                </mat-radio-group>



                <!-- CheckBox button (Multiple choice) -->
                <div fxLayout="column" fxLayoutGap="5px" *ngIf="cat.max_quantity > 1 && prodCopy.product_type === 1">

                  <!-- <mat-checkbox *ngFor="let det of cat.details" color="primary" [value]="det.product.id"
                    [checked]="det.product.quantity === 1" (change)="manageCheckBox(cat, det.product)"
                    angulartics2On="click" angularticsAction="selectProductOption" angularticsCategory="products">

                    <div fxLayout=row fxLayoutAlign="start center" fxflex>

                      <span class="mat-subheading-1">{{det.product.name | capitalize}}</span>
                      <div fxFlex></div>

                      <span class="mat-caption" *ngIf="det.product.price > 0">&nbsp;&nbsp;+{{det.product.price
                        |discountVipFilter:merchantClient:det.product | priceFilter}}</span>

                    </div>

                  </mat-checkbox> -->

                  <div *ngFor="let det of cat.details">


                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                      <!-- Remove -->
                      <div class="primary clicked quantity-toggle-btn " fxLayoutAlign="center center"
                        (click)="toggleProdQuantDet('-',cat, det.product)">
                        <span class="mat-caption">-</span>

                      </div>
                      <div class="mat-caption boldest" fxLayoutAlign="center center">{{det.product.quantity}}</div>


                      <!-- Add -->
                      <div class="primary clicked quantity-toggle-btn" fxLayoutAlign="center center"
                        (click)="toggleProdQuantDet('+',cat, det.product)">
                        <span class="mat-caption">+</span>
                      </div>


                      <div  fxLayout="row" fxFlex fxLayoutAlign="space-between center" fxLayoutGap="10px" class="hidden-overflow">

                        <div class="prod-title elipis">{{det.product.name | capitalize}}</div>

                        <div  class="mat-caption" *ngIf="det.product.price !== 0"> {{det.product.price<=0?"":"+"}}{{det.product.price
                          |discountVipFilter:merchantClient:det.product|priceFilter}}</div>

                      </div>

                    </div>



                  </div>


                </div>

              </div>
              <!--  discountVipFilter pas si Prod type 2 -->
              <!-- Prod type 2 -->

              <div fxLayout="row wrap" *ngIf="prodCopy.product_type === 2">

                <div *ngFor="let det of cat.details" style="height: 90px; padding: 5px;" class="rad-bord clicked"
                 (click)="openProdDial(det.product, 'formule', cat)" angulartics2On="click"
                  angularticsAction="selectProductDetail" angularticsCategory="products" fxFlex="100" fxFlex.xs="100">

                  <mat-card fxFlex class="rad-bord prod-card bordered-light no-shadow hidden-overflow"
                    [class.prodSelected]="(det.product.quantity && !det.product.stock) || det.product.quantity && (det.product.stock && getprodStock(det.product.id)>0)"
                    [matBadge]="det.product.quantity"
                    [matBadgeHidden]="cat.max_quantity > 1  && det.product.quantity < 1 || cat.max_quantity <= 1"
                    matBadgeColor="accent">
                    <!-- Out of stock  -->
                    <div class="out-of-stock-badge-grid text-align" fxLayoutAlign="center center"
                      *ngIf="det.product.stock && getprodStock(det.product.id) <= 0">
                      <span class="boldest mat-caption">{{'prodComponent.unavailable' |translate}}</span>
                    </div>

                    <mat-card-header [class.opacitygrid]="det.product.stock && getprodStock(det.product.id)===0">

                      <div mat-card-avatar class="pos-img-cont avatar-prod-card"
                        [class.out-of-stock-prod-stock]="det.product.stock && getprodStock(det.product.id)<=0"
                        [ngStyle]="{'background-image': 'url(' + ( det.product.image.length > 0 ? det.product.image[2] : default_prod) + ')'}">
                      </div>
                      <mat-card-title >
                        <div class="prod-title elipis" >
                        {{det.product.name | descFilter:50}}</div>
                      </mat-card-title>
                      <!-- <mat-card-title class="prod-title">{{det.product.name | descFilter:50}}</mat-card-title> -->

                      <mat-icon *ngIf="cat.max_quantity === 1" class="info_ico" [class.withed-ico]="det.quantity > 0"
                        [class.dark-ico]="det.quantity === 0"
                        (click)="openProdDial(det.product, 'formule', cat, index, true);$event.stopPropagation()"
                        angulartics2On="click" angularticsAction="openInfoProduct" angularticsCategory="products">
                        info_outline</mat-icon>

                      <mat-card-subtitle *ngIf="det.product.price !== 0" style="font-size: 15px;"
                        class="prod-card-price mat-subheading-1 boldest dark-ico">
                        {{det.product.price<=0?"":"+"}}{{det.product.price|discountVipFilter:merchantClient:det.product | priceFilter}}
                      </mat-card-subtitle>

                    </mat-card-header>

                  </mat-card>

                </div>

              </div>

            </div>

          </div>

          <!-- Prod Comment -->
          <div style="padding-top: 0;" *ngIf="prodCopy.enable_comment > 0" >

            <mat-form-field appearance="outline" class="full-w form-nopadd"  angulartics2On="click"
              angularticsAction="commentProd" angularticsCategory="products">
              <mat-label>{{"dialogs.prod.comment" | translate}}</mat-label>
              <input matInput type="text" placeholder="{{'dialogs.prod.comment' | translate}}" maxlength="200"
                [(ngModel)]="prodCopy.comment">
            </mat-form-field>

          </div>

          <!-- Compulsory asterisk -->
          <div *ngIf="prodCopy.product_type > 0">
            <span class="mat-caption">{{"dialogs.asterisk" | translate}}</span>

          </div>

        </div>

      </div>

      <!-- Button toggle quantity + button submit prod -->

      <div fxLayout="row" fxLayoutGap="10px" class="layout-padd-2" [ngStyle.gt-xs]="{'height': '60px'}"
        [ngStyle.xs]="{'height': '50px'}" ngClass.xs="resp-btn-bar" #fixedBar *ngIf="conditionStock() && !unaivalable">

        <div *ngIf="+maxQuantityRest  > 1 && !productSuggested" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">


          <div fxLayoutAlign="center center" class="btn-quant clicked btn-dyna primary" (click)="toggleProdQuant('-')"
            angulartics2On="click" angularticsAction="updateQuantityFromDialog" angularticsCategory="products" >
            <mat-icon class="whited-ico">remove</mat-icon>
          </div>

          <div fxLayoutAlign="center center">
            <span class="mat-subheading-1 boldest">{{prodCopy.quantity}}</span>
          </div>

          <div fxLayoutAlign="center center" class="btn-quant clicked btn-dyna primary" (click)="toggleProdQuant('+')"
            angulartics2On="click" angularticsAction="updateQuantityFromDialog" angularticsCategory="products">
            <mat-icon class="whited-ico">add</mat-icon>
          </div>

        </div>

        <div fxLayoutAlign="center center" fxFlex>


          <button mat-raised-button fxLayoutAlign="center center" class="primary rounded-button" (click)="pushProd()"
           [class.mydisabled]="prodCopy&&prodCopy.novisible"   fxFlex angulartics2On="click"
            angularticsAction="{{ from === 'add' ? 'addProduct' :  from === 'update' ? 'updateProduct' : from === 'formule' ? 'addProductToMenu' : from === 'updatedetail' ? 'updateFormuleDetail' : ''}}"
            angularticsCategory="products" style="height: 30px;">

            <span fxHide.xs *ngIf="FormuleSuggested || from === 'add'">{{"dialogs.prod.add" | translate}}</span>
            <span fxHide fxShow.xs *ngIf="FormuleSuggested ||from === 'add'">{{'prodComponent.add' |translate}}</span>


            <span fxHide.xs *ngIf="!FormuleSuggested && (from === 'update' || from === 'updatedetail')">{{"dialogs.prod.update" |
              translate}}</span>
            <span fxHide fxShow.xs *ngIf="!FormuleSuggested &&  (from === 'update' ||from === 'updatedetail')">{{'button.modify'|translate}}</span>

            <span *ngIf="from === 'formule'">{{'prodComponent.addForm' |translate}}</span>


            <span class="mat-subheading-1 boldest" ngClass.xs="mat-caption"
              *ngIf="getTotalPriceFormule() !== 0">&nbsp;&nbsp;({{(from
              === 'formule' || from === 'updatedetail')&& getTotalPriceFormule()>0 ? '+' :''}}{{getTotalPriceFormule() | priceFilter}})</span>

          </button>

        </div>

      </div>

      <!-- Baniere indisponible en bas de la popup formule-->
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" class="out-of-stock-button layout-padd-2"
        [ngStyle.gt-xs]="{'height': '60px'}" [ngStyle.xs]="{'height': '50px'}" ngClass.xs="resp-btn-bar" #fixedBar
        *ngIf="!conditionStock() || unaivalable">
        <span class="mat-title boldest">{{'prodComponent.unavailable' |translate}}</span>
      </div>

    </mat-sidenav-content>


    <!-- List formule details (Prod type 2) -->
    <mat-sidenav position="end" [opened]="opened" [mode]="mode" style="width: 280px;" [ngStyle.xs]="{'width': '90%'}"
      #rightNav>

      <div fxLayout="column" fxFlexFill>

        <!-- Header xs mode with close sidenav button -->
        <div fxHide fxShow.lt-md class="layout-padd light">
          <mat-icon class="clicked" (click)="rightNav.close()">navigate_next</mat-icon>
        </div>

        <div class="scrolled">

          <div *ngFor="let cat of formuleDetails">

            <!-- Categorie title -->
            <div fxLayoutAlign="space-between center" class="divider" style="padding: 10px;">
              <span class="mat-title">{{cat.name | capitalize}}</span>
              <span class="mat-caption">{{'prodComponent.max' |translate}} {{cat.max_quantity}}</span>
            </div>

            <div fxLayout="column" fxLayoutGap="10px" class="layout-padd" *ngIf="cat.details.length > 0">

              <div fxLayout="column" *ngFor="let det of cat.details; let last = last; let index = index;"
                [class.divider]="!last">

                <div fxLayoutAlign="space-between center">

                  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="hidden-overflow">
                    <img *ngIf="det.image.length > 0" [src]="det.image[2]" style="height: 40px; border-radius: 50%;">
                    <img *ngIf="det.image.length < 1" [src]="default_prod" style="height: 40px; border-radius: 50%;">
                    <div class="mat-subheading-1 elipis">{{det.name | capitalize}}</div>
                  </div>




                  <div class="mat-subheading-1 boldest"
                    *ngIf="det.price !== 0 && det.details&& det.details.length > 0 ">{{det.price<=0?"":"+"}}{{ getTotalProdPrice(det) |
                    priceFilter}}</div>

                  <div class="mat-subheading-1 boldest"
                    *ngIf="det.price !== 0 &&  det.details&&  det.details.length < 1 && det.details">{{det.price<=0?"":"+"}}{{ det.price
                    |discountVipFilter:merchantClient:det | priceFilter}}</div>
                </div>

                <!-- Details of categories details -->
                <div fxLayout="column" class="full-w" style="padding-left: 50px;"
                  *ngIf="det.details && det.details.length > 0">

                  <div fxLayoutAlign="space-between center" *ngFor="let sdet of det.details" >
                    <!-- <span class="mat-caption">{{sdet.name | capitalize}}</span>

                    <span class="mat-caption" *ngIf="sdet.price > 0">+{{sdet.price
                      |discountVipFilter:merchantClient:sdet | priceFilter}}</span> -->


                    <!-- new -->
                    <div fxLayout="row" class="hidden-overflow">
                      <div class="mat-caption" style="font-size: x-small"
                        *ngIf="sdet.quantity > 1 || prod.quantity>1">{{ sdet.quantity
                        * prod.quantity }}&nbsp;&nbsp;</div>
                      <div class="mat-caption elipis">{{sdet.name | capitalize}}</div>
                    </div>

                    <span class="mat-caption" *ngIf="sdet.price !== 0">{{sdet.price<=0?"":"+"}}{{(sdet.price
                      |discountVipFilter:merchantClient:sdet)*sdet.quantity*
                      prod.quantity | priceFilter}} </span>



                  </div>

                </div>

                <!-- Det comment -->
                <div *ngIf="det.comment" class="layout-padd-2">
                  <div class="mat-caption elipis" style="font-style: italic;">{{det.comment | descFilter:100}}</div>
                </div>

                <!-- Update and delete button -->
                <div fxLayoutAlign="end center" fxLayoutGap="10px">

                  <div>
                    <span class="mat-caption primary-ico clicked" *ngIf="det.product_type > 0"
                      (click)="openProdDial(det, 'updatedetail', cat, index)" angulartics2On="click"
                      angularticsAction="deleteDetailFormule" angularticsCategory="products">{{'prodComponent.modify' |translate}}</span>
                  </div>

                  <div>
                    <span class="mat-caption warn-ico clicked" (click)="deleteFormuleDetail(cat.id, det.id, index)"
                      angulartics2On="click" angularticsAction="updateDetailFormule"
                      angularticsCategory="products">{{'prodComponent.delete' |translate}}</span>
                  </div>

                </div>

              </div>

            </div>

            <div fxLayoutAlign="center center" class="layout-padd" *ngIf="cat.details.length < 1">
              <span class="mat-subheading-1">{{'prodComponent.noproductadd' |translate}}</span>
            </div>

          </div>

        </div>

      </div>

    </mat-sidenav>

  </mat-sidenav-container>

</div>

<app-popup-loader [flagLoading]="loaderpop" [size]="30" [statusMessage]=" " [transparent]="loaderTransparent">
</app-popup-loader>
